import React from 'react';
import {
    Route,
    Redirect
} from "react-router-dom";




class AdminRoute extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        const { component: Component, ...rest } = this.props;
        return (
            <Route
            {...rest}
            render={props => this.props.isAuthed()
                ? (<Component {...props} />)
                : (<Redirect to={{pathname: '/login/admin', state: {from: props.location}}} />)}
            />
        )
    }
}

export default AdminRoute;